"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataRefMarker = void 0;
const names_and_enums_1 = require("../names-and-enums");
exports.DataRefMarker = `${names_and_enums_1.WranggleReservedPrefix}${names_and_enums_1.ReservedKeyType.DataRef}`; // '_$w_ref'
//# sourceMappingURL=data-ref.js.map